import { css } from '@emotion/css';

/**
 * CSS overrides applied when the Gantt view is mounted inside an
 * `affine-edgeless-database` block (canvas mode). The root
 * `DatabaseBlockComponent` already strips doc-mode's negative-margin
 * class; this class carries the positive adjustments Gantt needs on
 * top of that baseline.
 *
 * Applied via a `gantt-mode` attribute on the root element — see
 * {@link detectEdgelessMode}.
 */
export const ganttEdgelessModeStyle = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  // Doc mode leaks scrollbars from parent — in canvas mode the gantt
  // owns its scroll container.
  contain: 'layout style size',
  // Ensure the gantt-body fills the surface-sized xywh bounds.
  '& > div': {
    flex: '1 1 auto',
  },
});

export const ganttDocModeStyle = css({
  width: '100%',
  // In page mode the note carries the scroll; let the gantt grow
  // within its natural height and rely on the outer scroll.
  minHeight: '320px',
});
